import { FC, SVGProps } from 'react';

export enum IconColor {
  white = 'white',
  blue = 'blue',
  red = 'red',
  pink = 'pink',
  darkTan = 'dark-tan',
  brown = 'brown',
  dark = 'dark',
  darkRed = 'darkred',
  green = 'green',
  deepDark = 'deep-dark',
  strokeDark = 'stroke-dark',
  strokeDarkTan = 'stroke-dark-tan'
}

export type SVGComponent = FC<SVGProps<SVGSVGElement>>;

export interface IconProps {
  IconComponent: SVGComponent;
  width?: number;
  height?: number;
  color?: IconColor | string;
  indent?: boolean;
  lgIndent?: boolean;
  pathColor?: IconColor | string;
  iconNeedColorChange?: boolean;
  onClick?: () => void;
  dataCypress?: string;
  ariaLabel?: string;
}
